import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface PasswordRequirementsProps {
  password: string;
  confirmPassword?: string;
}

export function PasswordRequirements({ password, confirmPassword }: PasswordRequirementsProps) {
  const { t } = useTranslation();
  const [checks, setChecks] = useState({
    length: false,
    uppercase: false,
    digit: false,
    special: false,
    match: false,
  });

  useEffect(() => {
    setChecks({
      length: password.length >= 8 && password.length <= 14,
      uppercase: /[A-Z]/.test(password),
      digit: /[0-9]/.test(password),
      special: /[!@#$%^&*]/.test(password),
      match: confirmPassword !== undefined ? password === confirmPassword && password.length > 0 : true,
    });
  }, [password, confirmPassword]);

  const requirements: { key: keyof typeof checks; label: string }[] = [
    { key: 'length', label: t('general.passwordTooShort') },
    { key: 'uppercase', label: t('general.passwordMissingUppercase') },
    { key: 'digit', label: t('general.passwordMissingDigit') },
    { key: 'special', label: t('general.passwordMissingSpecial') },
    ...(confirmPassword !== undefined ? [{ key: 'match' as keyof typeof checks, label: t('general.passwordsDontMatch') }] : []),
  ];

  return (
    <div className="text-sm space-y-1 mt-2">
      {requirements.map((req) => (
        <div key={req.key} className="flex items-center gap-2">
          <span className={checks[req.key] ? 'text-green-600' : 'text-gray-400'}>
            {checks[req.key] ? '✓' : '○'}
          </span>
          <span className={checks[req.key] ? 'text-green-600' : 'text-gray-500'}>{req.label}</span>
        </div>
      ))}
    </div>
  );
}
